<template>
  <v-dialog v-model="plannificationPramsDataIsOpen" width="99%" max-width="1300">
    <v-card variant="flat">
      <v-col class="pa-1">
        <generator
          :userInformation="userInformation"
          :blogListe="blogListe"
          :nbrMaxGeneration="nbrMaxGeneration"
          :getNbrLoadingArticle="getNbrLoadingArticle"
          :getSquedueldata="getSquedueldata"
          :updateData="updateData"
          :windowHeight="windowHeight"
          :groupInformation="groupInformation"
          :updateCalendar="updateCalendar"
        >
        </generator>
      </v-col> </v-card
  ></v-dialog>
  <v-dialog v-model="selectedGeneratonData.modal" width="99%" max-width="600">
    <v-card v-if="selectedGeneratonData.data">
      <v-col class="pa-4 pb-1" align="center" style="font-size: 18px; font-weight: bold">
        Modification de la publication
        <v-btn
          @click="selectedGeneratonData.modal = false"
          style="position: absolute; right: 5px; top: 5px"
          icon="mdi-close"
          color="red"
          density="compact"
        ></v-btn>
      </v-col>
      <div
        v-if="selectedGeneratonData.data.isGenerate != 0"
        class="pa-4 py-0"
        style="color: red; font-size: 14px; font-weight: bold"
      >
        <!-- Article déjà généré, modification impossible utiliser une autre ligne de
          génération -->
        Les modifications d’un article déjà généré ne peuvent pas être effectuées depuis
        cet emplacement. Veuillez vous rendre dans votre calendrier éditorial pour les
        réaliser.
      </div>

      <v-col>
        <v-row>
          <v-col>
            <!-- <v-col>
              <v-select
                class="no-dropdown-icon"
                label="Publication"
                v-model="selectedGeneratonData.data.date"
                :items="[...Array(28).keys()].map((n) => n + 1)"
                :hide-spin-buttons="false"
                hide-details
              >
                <template v-slot:selection="{ item }">
                  <div>
                    Jour de publication
                    <v-chip density="compact">{{ item.title }}</v-chip>
                    <br />
                    <span style="color: green; font-size: 12px; font-weight: bold">
                      Prochaine publication {{ getPuclicationDate(item.title) }}
                    </span>
                  </div>
                </template>
              </v-select>
            </v-col> -->
            <!-- <v-col>
              <v-textarea
                :readonly="selectedGeneratonData.data.isGenerate != 0"
                label="Article"
                v-model="selectedGeneratonData.data.requeste"
                hide-details
                rows="1"
                auto-grow
                clearable
              ></v-textarea>
              <div
                v-if="selectedGeneratonData.data.isGenerate != 0"
                class="pa-2 pb-0"
                style="color: red; font-size: 11px; font-weight: bold"
              >
                Article déjà publié, modification impossible utiliser une autre ligne de
                génération
              </div>
            </v-col> -->
            <v-col>
              <v-card color="#81C784" variant="flat">
                <v-textarea
                  :readonly="selectedGeneratonData.data.isGenerate != 0"
                  label="Requête cible"
                  v-model="selectedGeneratonData.data.requeste"
                  hide-details
                  rows="1"
                  auto-grow
                  :clearable="!(selectedGeneratonData.data.isGenerate != 0)"
                ></v-textarea>
              </v-card>
            </v-col>

            <v-col v-if="groupInformation.web_site_data[selectedPlatformToShow]">
              <v-select
                label="Site de publication"
                item-title="label"
                v-model="selectedGeneratonData.data.site"
                item-value="uuid"
                :items="groupInformation.web_site_data[selectedPlatformToShow]"
                hide-details
                @update:model-value="selectedGeneratonData.data.idBlog = undefined"
              >
              </v-select>
            </v-col>
            <v-col
              v-if="
                selectedGeneratonData.data.site &&
                groupInformation.web_site_data[selectedPlatformToShow].find(
                  (val) => val.uuid == selectedGeneratonData.data.site
                ) &&
                groupInformation.web_site_data[selectedPlatformToShow].find(
                  (val) => val.uuid == selectedGeneratonData.data.site
                ).publication_platform_data &&
                groupInformation.web_site_data[selectedPlatformToShow].find(
                  (val) => val.uuid == selectedGeneratonData.data.site
                ).publication_platform_data.length > 1
              "
            >
              <v-select
                return-object
                label="Blog de publication"
                item-title="label"
                clearable
                v-model="selectedGeneratonData.data.idBlog"
                :items="
                  JSON.parse(
                    groupInformation.web_site_data[selectedPlatformToShow].find(
                      (val) => val.uuid == selectedGeneratonData.data.site
                    ).publication_platform_data
                  )
                "
                hide-details
              >
              </v-select>
            </v-col>
            <v-col
              v-if="
                groupInformation.templates.content &&
                groupInformation.templates.content.length != 0
              "
            >
              <v-select
                :readonly="selectedGeneratonData.data.isGenerate != 0"
                label="Rédacteur"
                item-title="title"
                item-value="idx"
                v-model="selectedGeneratonData.data.type"
                :items="groupInformation.templates.content"
                hide-details
              >
              </v-select>
            </v-col>
            <!-- <v-col
        v-if="
          groupInformation.templates.length.filter(
            (val) => val.platform == selectedPlatformToShow && val.show == true
          ).length > 1
        "
      >
        <v-select
          label="Longeur"
          class=""
          hide-details
          return-object
          v-model="selectedGeneratonData.data.length"
          :items="
            groupInformation.templates.length.filter(
              (val) => val.platform == selectedPlatformToShow && val.show == true
            )
          "
        ></v-select>
      </v-col> -->
            <!-- <v-col v-if="redacteurListe.filter((val) => val.show == true).length > 1">
        <v-select
          label="Rédacteur"
          class=""
          hide-details
          v-model="selectedGeneratonData.data.redacteur"
          :items="redacteurListe.filter((val) => val.show == true)"
        ></v-select>
      </v-col> -->
          </v-col>
          <v-col
            class="pl-0 py-0"
            cols="6"
            v-if="
            false &&
              groupInformation &&
              groupInformation['proposition_data'] &&
              groupInformation['proposition_data'].length > 0 &&
              groupInformation['proposition_data'].filter(
                (val) => val.site_id == selectedSiteToShow.uuid
              ).length > 0
            "
          >
            <v-card variant="text" style="color: white" class="bg">
              <v-col class="pb-1" style="font-weight: bold" align="center">
                Proposition de publication
              </v-col>
              <v-divider class="mt-1"></v-divider>
              <v-col>
                <v-row>
                  <v-col class="pb-0" cols="12">
                    <v-card style="">
                      <v-select
                        density="compact"
                        v-model="selectedKeyWords"
                        label="Mot clef cible"
                        item-title="term"
                        :items="
                          groupInformation['proposition_data'].filter(
                            (val) => val.site_id == selectedSiteToShow.uuid
                          )
                        "
                        return-object
                        hide-details
                      >
                        <template v-slot:label="{ label }">
                          <div align="center" style="width: 100vw; font-weight: bold">
                            {{ label }}
                          </div>
                        </template>
                        <template v-slot:selection="{ item }">
                          <div
                            align="center"
                            style="width: 100vw; font-weight: bold; font-size: 14px"
                          >
                            {{ item.title }}
                          </div>
                        </template>
                        <template v-slot:item="{ props }">
                          <v-list-item v-bind="props" align="left"> </v-list-item>
                        </template>
                      </v-select>
                    </v-card>
                  </v-col>
                  <v-col class="" cols="12" v-if="selectedKeyWords">
                    <v-card>
                      <v-select
                        density="compact"
                        label="Thème d'article proposé"
                        v-model="selectedTheme"
                        item-title="questionVerified"
                        :items="selectedKeyWords.results"
                        return-object
                        hide-details
                      >
                        <template v-slot:label="{ label }">
                          <div align="center" style="width: 100vw">
                            {{ label }}
                          </div>
                        </template>
                        <template v-slot:selection="{ item }">
                          <div
                            align="center"
                            style="width: 100vw; font-weight: bold; font-size: 12px"
                          >
                            {{ item.title }}
                          </div>
                        </template>
                        <template v-slot:item="{ props }">
                          <v-list-item v-bind="props" align="left"> </v-list-item>
                        </template>
                      </v-select>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                v-if="selectedTheme"
                class="pa-4"
                style="overflow-x: auto"
                :style="{
                  height: windowHeight - 445 + 'px',
                  'background-color': 'rgba(255, 255, 255, 0.3)',
                }"
              >
                <v-row align="center">
                  <v-col
                    v-for="(questions, a) in selectedTheme.results"
                    :key="a"
                    class="pa-1"
                    cols="12"
                    align="center"
                  >
                    <v-card
                      align="left"
                      class="buttonReverse pa-2"
                      style="font-size: 14px; border-radius: 5px !important"
                      :style="{
                        'background-color': getProgrammedArticleTitle.includes(
                          questions.questionVerified
                        )
                          ? 'lightgrey !important'
                          : '',
                        color: getProgrammedArticleTitle.includes(
                          questions.questionVerified
                        )
                          ? 'grey !important'
                          : '',
                      }"
                      @click="
                        selectedGeneratonData.data.requeste = questions.questionVerified
                      "
                    >
                      <!-- @click="setArticle(selectedSiteToShow.uuid, questions)" -->
                      {{ a + 1 }} - {{ questions.questionVerified }}
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-card>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-col>
          <v-row justify="center" align="center">
            <v-col v-if="false">
              <v-switch
                :label="
                  selectedGeneratonData.data.isActived == 1
                    ? 'Activer : Oui'
                    : 'Activer : Non'
                "
                density="compact"
                v-model="selectedGeneratonData.data.isActived"
                align="center"
                hide-details
                style="font-weight: bold"
                :style="{
                  color: selectedGeneratonData.data.isActived == 1 ? '#388E3C' : 'red',
                }"
                inset
                :false-value="0"
                :true-value="1"
              ></v-switch>
            </v-col>
            <v-col align="right" v-if="selectedGeneratonData.data.isGenerate == 0">
              <v-btn
                @click="generateArticle"
                class="button"
                :disabled="
                  getNbrLoadingArticle >= nbrMaxGeneration ||
                  groupInformation.article_month_generated_max -
                    groupInformation.article_month_generated <=
                    0 ||
                  selectedGeneratonData.data.requeste == undefined ||
                  selectedGeneratonData.data.requeste.length == 0
                "
              >
                Générer maintenant
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-col>
      <v-col cols="12" align="center" class="pt-0">
        <v-divider class="mb-4"></v-divider>
        <v-btn class="button" @click="updatePublication"> Enregistrer </v-btn>
      </v-col>
    </v-card>
  </v-dialog>
  <!-- <v-dialog v-model="modalIsOpen['editShopifyArticle']" persistent fullscreen> -->
  <v-dialog v-model="modalIsOpen['editShopifyArticle']" persistent>
    <v-card>
      <div align="center">
        <editShopifyArticle
          :fullScreen="false"
          :getOperatingSystem="getOperatingSystem"
          :closeModal="
            function () {
              modalIsOpen['editShopifyArticle'] = false;
            }
          "
          :userInformation="userInformation"
          :groupInformation="groupInformation"
          :closeFunction="
            function () {
              modalIsOpen['editShopifyArticle'] = false;
              onDatesChange();
            }
          "
          :dataForm="modalData"
          :windowHeight="windowHeight"
          :siteListe="blogListe"
        >
        </editShopifyArticle>
      </div>
    </v-card>
  </v-dialog>
  <div style="position: relative">
    <v-card class="pa-2" style="position: relative">
      <FullCalendar ref="calendarRef" class="pa-2" :options="calendarOptions" />
    </v-card>
    <v-hover v-slot="{ isHovering, props }">
      <div
        v-if="!isMobile"
        v-bind="props"
        style="position: absolute; right: 3%; bottom: -25px"
        class="py-2"
        cols="12"
      >
        <v-card
          class="pa-2"
          style="border: solid 2px var(--C1)"
          :style="{ visibility: isHovering == true ? 'hidden' : 'visible' }"
        >
          <v-row justify="left" align="center" class="px-2">
            <v-col v-for="(elem, i) in legend" :key="i" cols="auto" class="px-1">
              <v-card
                class="px-2 py-1"
                :color="elem.color"
                style="border-radius: 10px; color: white"
                variant="flat"
              >
                <!-- <v-icon :color="elem.color">mdi-circle</v-icon> -->
                {{ elem.title }}
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </div>
    </v-hover>
    <v-snackbar
      v-model="snackData.model"
      :color="snackData.color"
      timeout="5000"
      style="font-weight: bold"
    >
      <!-- <v-col style="font-weight: bold;color:white;font-size: 19px;"> -->
      {{ snackData.label }}
      <!-- </v-col> -->
    </v-snackbar>
  </div>
</template>

<script>
import FullCalendar from "@fullcalendar/vue3";
import dayGridPlugin from "@fullcalendar/daygrid";
// import rrulePlugin from "@fullcalendar/rrule";
import listPlugin from "@fullcalendar/list";

import moment from "moment";
import { v4 as uuidv4 } from "uuid";

import fr from "@fullcalendar/core/locales/fr";
import engine from "@/core/index";

import editShopifyArticle from "@/components/blog/blog-article-edition.vue";
import generator from "@/view/view-generator.vue";

export default {
  components: {
    generator,
    FullCalendar,
    editShopifyArticle,
  },
  props: {
    nbrMaxGeneration: {},
    getSquedueldata: { type: Function },
    updateData: { type: Function },
    getUserData: { type: Function },
    windowHeight: {},
    openProgrammation: {},
    userInformation: {},
    groupInformation: {},
    getOperatingSystem: {},
    blogListe: {},
  },
  mounted() {
    this.initPostData();
    this.selectedSiteToShow = this.groupInformation.web_site_data[
      this.selectedPlatformToShow
    ][0];

    if (this.isMobileSm) this.changerVue("dayGridMonth");
    else this.changerVue("listMonth");
  },
  data() {
    return {
      snackData: {},
      initialView: undefined,
      autoPostDataInfo: {},
      legend: [
        {
          key: "desactived",
          title: "Publication désactivée",
          color: "#D32F2F",
          desc: "lllllllll",
        },
        { key: "past", title: "À replanifier", color: "#F57C00", desc: "#F57C00" },
        {
          key: "waiting",
          title: "Publication à venir",
          color: "#303F9F",
          desc: "#303F9F",
        },
        {
          key: "",
          title: "Génération à venir",
          color: "#90A4AE",
          desc: "#303F9F",
        },
        { key: "publish", title: "Publié", color: "#388E3C", desc: "dee" },
      ],
      plannificationPramsDataIsOpen: false,
      onDatesChangeArgs: undefined,
      eventsListeRecu: [],
      selectedPlatformToShow: "article_seo",
      platformToShow: ["article_seo"],
      selectedSiteToShow: undefined,
      selectedTheme: {},
      selectedKeyWords: undefined,
      blogToPublish: {},
      basicData: undefined,
      globalActivation: {},
      isArticleSelected: {
        num: 1,
      },
      selectedKeyWordData: {},
      selectedThemeData: {},
      autoPostData: {},
      isSavePageOpen: false,
      daysToPubli: [1, 28],
      programationData: {},
      selectedGeneratonData: {
        modal: false,
        data: {},
      },
      modalData: undefined,
      dataListe: undefined,
      modalIsOpen: {},
      eventsListe: [],
    };
  },
  watch: {
    isMobileSm(val) {
      if (val) this.changerVue("dayGridMonth");
      else this.changerVue("listMonth");
    },
    isMobile() {
      this.onDatesChange();
    },
    async selectedSiteToShow(valSite) {
      this.selectedTheme = undefined;
      if (
        this.groupInformation["proposition_data"] &&
        this.groupInformation["proposition_data"].length > 0
      )
        this.selectedKeyWords = this.groupInformation["proposition_data"].find(
          (val) => val.site_id == valSite.uuid
        );
    },
    selectedKeyWords() {
      this.selectedTheme = undefined;
      if (
        this.selectedKeyWords &&
        this.selectedKeyWords.results &&
        this.selectedKeyWords.results[0]
      )
        this.selectedTheme = this.selectedKeyWords.results[0];
    },
  },
  methods: {
    generateArticle() {
      // updatePublication
      // this.selectedGeneratonData = {
      //   modal: true,
      //   data,
      // };
      this.selectedGeneratonData.data.isGenerate = 1;
      let that = this;
      let today = new Date();
      let month = today.getMonth() + 1; // Les mois commencent à 0, donc on ajoute 1
      let year = today.getFullYear();
      let dateDay = this.selectedGeneratonData.data.date;

      if (today.getDate() > dateDay) {
        month = month + 1;
        if (month == 13) {
          month = 1;
          year = year + 1;
        }
      }

      if (month < 10) month = "0" + month;
      if (dateDay < 10) dateDay = "0" + dateDay;

      let randomNumber = Math.floor(Math.random() * (18 - 12 + 1)) + 12;
      let date = month + "/" + dateDay + "/" + year;

      let obj = {
        onlyPlan: "false",
        chatgptQuestion: { title: this.selectedGeneratonData.data["requeste"] },
        dataForm: {
          publication_date: { value: date },
          publication_time: { value: randomNumber + ":00" },
          publication_datetime: { value: "" },
          publication_id: { value: "" },
          post_compte_id: { value: "" },
          file_ids: { value: [] },
          user: {
            value: {
              lastname: "Jauris",
              firstname: "BOT",
              user_id: "0000000000",
              group_id: this.groupInformation.id,
            },
          },
          group: {
            value: {
              id: this.groupInformation.id,
              assistant_id: this.groupInformation.assistant_id,
              album_data: this.groupInformation.album_data,
            },
          },
          thread: { value: "" },
          tags: { value: "" },
          metadata: { value: "" },
          optionalContent: { value: { content: {} } },
        },
      };
      obj["selectedTemplate"] = {};

      obj["selectedTemplate"]["content"] = this.groupInformation.templates.content.find(
        (val) => val.idx == this.selectedGeneratonData.data["type"]
      );

      if (obj["selectedTemplate"]["content"] == undefined)
        obj["selectedTemplate"]["content"] = this.basicData.templates.content.find(
          (val) => val.idx == this.selectedGeneratonData.data["type"]
        );

      if (
        this.groupInformation.web_site_data &&
        this.groupInformation.web_site_data[obj["selectedTemplate"]["content"].type]
      )
        obj["selectedSite"] = this.groupInformation.web_site_data[
          obj["selectedTemplate"]["content"].type
        ].find((val) => val.uuid == this.selectedGeneratonData.data["site"]);

      //  {
      //     content: this.groupInformation.templates.content.find(
      //       (val) => val.idx == this.selectedGeneratonData.data["type"]
      //     ),
      //     // length: this.groupInformation.templates.length.find(
      //     //   (val) => val.idx == this.selectedGeneratonData.data["length"].idx
      //     // ),
      //     // redacteur: this.redacteurListe.find(
      //     //   (val) => val.idx == this.selectedGeneratonData.data["redacteur"].idx
      //     // ),
      //   },
      //   selectedSite: this.groupInformation.web_site_data[
      //     this.selectedGeneratonData.data["type"].type
      //   ].find((val) => val.uuid == this.selectedGeneratonData.data["site"]),

      if (
        this.selectedGeneratonData.data.idBlog &&
        this.selectedGeneratonData.data.idBlog.id
      )
        obj.dataForm["post_compte_id"] = {
          value: { id: this.selectedGeneratonData.data.idBlog.id },
        };

      that.selectedGeneratonData.data.isGenerate = 1;

      // that.updatePublication();

      if (that.userInformation.klaviyo && that.userInformation.klaviyo.length > 0) {
        obj["klaviyo"] = that.userInformation.klaviyo;
        engine.set_klaviyo_event(
          that.userInformation.klaviyo,
          "Génération manuelle d'un article : " + obj.chatgptQuestion.title
        );
      }

      if (
        obj.selectedTemplate.content == undefined ||
        obj.selectedTemplate.content.type == undefined ||
        obj.selectedTemplate.content.type == "article_seo"
      ) {
        engine.creat_shopify_article_from_server(obj, function () {
          // that.getSquedueldata();
          // that.closeModalAndSave();
        });

        that.updatePublication();
        setTimeout(function () {
          that.onDatesChange();
        }, 2000);
      }
    },
    changerVue(nouvelleVue) {
      this.initialView = nouvelleVue; // optionnel, pour suivre la vue active
      const calendarApi = this.$refs.calendarRef.getApi();
      calendarApi.changeView(nouvelleVue);
    },
    updateCalendar(data) {
      let that = this;
      engine.set_auto_post_data(
        this.groupInformation.id,
        JSON.stringify(data),
        function () {
          that.getUserData(function () {
            that.initPostData();
            // that.setPlanning();
          });
        }
      );
    },
    initPostData() {
      let that = this;
      engine.get_basic_data(function (basic_data) {
        if (basic_data.state == 200) {
          that.basicData = {
            // redacteur: JSON.parse(basic_data.data[0].redacteur),
            // settings: JSON.parse(basic_data.data[0].settings),
            templates: JSON.parse(basic_data.data[0].templates),
            // web_site_data: JSON.parse(basic_data.data[0].web_site_data),
          };

          // let redacteurBasic = that.basicData.redacteur.filter((val) => val.show == true);

          // let redacteurGroupe = that.groupInformation.templates.redacteur.filter(
          //   (val) => val.show == true
          // );

          // that.redacteurListe = redacteurGroupe.concat(redacteurBasic);
        }
        engine.get_auto_post_data(that.groupInformation.id, function (data) {
          if (data.state == 200) {
            let auto_post_data = data.data[0];
            if (auto_post_data.auto_post_data) {
              that.autoPostData = JSON.parse(auto_post_data.auto_post_data);
              that.updateAutoPostData();
              that.setPlanning();
            }
          } else {
            that.autoPostData = {};
          }
          that.verifGenerationListeSize();
        });
      });
    },
    updateAutoPostData() {
      let siteListe = [];
      for (const data of Object.values(this.groupInformation.web_site_data)) {
        siteListe = siteListe.concat(data);
      }

      for (const ListeProgramation of Object.values(this.autoPostData)) {
        if (ListeProgramation && ListeProgramation.nbr_progra)
          for (let i = 0; i < ListeProgramation.nbr_progra.length; i++) {
            let prog = ListeProgramation.nbr_progra[i];

            // if (
            //   prog.redacteur &&
            //   this.redacteurListe.find(
            //     (val) => val.idx == prog.redacteur.idx && val.show == true
            //   )
            // )
            //   prog.redacteur = this.redacteurListe.find(
            //     (val) => val.idx == prog.redacteur.idx && val.show == true
            //   );
            // else
            //   prog.redacteur = this.redacteurListe.find(
            //     (val) => val.show == true && val.default_selected == true
            //   );

            // if (
            //   this.groupInformation.templates.length.find(
            //     (val) => val.idx == prog.length.idx && val.show == true
            //   )
            // )
            //   prog.length = this.groupInformation.templates.length.find(
            //     (val) => val.idx == prog.length.idx && val.show == true
            //   );
            // else
            //   prog.length = this.groupInformation.templates.length.find(
            //     (val) => val.show == true && val.default_selected == true
            //   );

            if (siteListe.find((val) => val.uuid == prog.site.uuid)) {
              let findedSite = siteListe.find((val) => val.uuid == prog.site.uuid);
              if (findedSite)
                prog.site = siteListe.find((val) => val.uuid == prog.site.uuid).uuid;
            }

            if (
              prog.site.publication_platform_data &&
              prog.site.publication_platform_data.length > 0
            ) {
              let publication_platform_data = JSON.parse(
                prog.site.publication_platform_data
              );
              prog.idBlog = publication_platform_data[0];
            }

            // if (
            //   this.blogToPublish[prog.site.platform] &&
            //   this.blogToPublish[prog.site.platform][prog.site.uuid]
            // ) {
            //   let BlogToPublish = [];
            //   BlogToPublish = this.blogToPublish[prog.site.platform][prog.site.uuid];
            //   if (BlogToPublish.length > 0) prog.idBlog = BlogToPublish[0];
            // }

            if (
              this.groupInformation.templates.content.find(
                (val) => val.idx == prog.type.idx && val.show == true
              )
            )
              prog.type = this.groupInformation.templates.content.find(
                (val) => val.idx == prog.type.idx && val.show == true
              ).idx;
          }
      }
    },
    addGeneration(platform, id, key, site) {
      if (this.programationData[id] == undefined) this.programationData[id] = {};
      if (this.programationData[id][key] == undefined)
        this.programationData[id][key] = [];

      let type = this.groupInformation.templates.content.filter(
        (val) => val.type == platform && val.show == true
      );

      if (type.length == 0) type = this.basicData.templates.content;
      // let display = this.groupInformation.templates.display.filter(
      //   (val) => val.platform == platform && val.show == true
      // );
      // let length = this.groupInformation.templates.length.filter(
      //   (val) => val.platform == platform && val.show == true
      // );
      // let  redacteur = this.redacteurListe.find((val) => val.default_selected == true).map((val2) => ({idx:val2.idx}));
      let idBlog = undefined;

      if (site.publication_platform_data && site.publication_platform_data.length > 0) {
        let publication_platform_data = JSON.parse(site.publication_platform_data);
        idBlog = publication_platform_data[0];
      }

      let item = {
        date: 1,
        // redacteur,
        type: type[0].idx,
        // display: display[0],
        // length: length[0],
        site: site.uuid,
        idBlog,
        requeste: "",
        isGenerate: 0,
        isActived: 1,
        uuid: uuidv4(),
      };

      if (this.autoPostData[id] == undefined) this.autoPostData[id] = {};
      if (this.autoPostData[id][key] == undefined) this.autoPostData[id][key] = [];

      this.autoPostData[id][key].push(item);
    },
    removeGeneration(id, key) {
      // if (this.programationData[id] == undefined)
      //     this.programationData[id] = {}
      // if (this.programationData[id][key] == undefined)
      //     this.programationData[id][key] = []
      this.autoPostData[id][key].splice(-1);
    },
    verifGenerationListeSize() {
      for (let i = 0; i < this.platformToShow.length; i++) {
        let platform = this.platformToShow[i];
        let siteListe = this.groupInformation.web_site_data[this.selectedPlatformToShow];

        for (let b = 0; b < siteListe.length; b++) {
          let site = siteListe[b];

          if (!this.autoPostData) this.autoPostData = {};
          if (!this.autoPostData[site.uuid])
            this.autoPostData[site.uuid] = { nbr_progra: [] };

          if (this.autoPostData[site.uuid] && this.autoPostData[site.uuid].nbr_progra) {
            let nbrProgrammation = this.autoPostData[site.uuid].nbr_progra.length;
            let nbrMax = this.groupInformation.article_month_generated_max;

            if (nbrProgrammation < nbrMax) {
              while (nbrProgrammation < nbrMax) {
                this.addGeneration(platform, site.uuid, "nbr_progra", site);
                nbrProgrammation += 1;
              }
            } else if (nbrProgrammation > nbrMax) {
              while (nbrProgrammation > nbrMax) {
                this.removeGeneration(site.uuid, "nbr_progra");
                nbrProgrammation -= 1;
              }
            }
          }
        }
      }
      // this.closeModalAndSave();
    },
    forcerRefreshCalendrier() {
      const calendarApi = this.$refs.calendarRef.getApi();
      const currentDate = calendarApi.getDate();

      // Aller à une autre date (bidon)
      const tempDate = new Date(currentDate);
      tempDate.setDate(currentDate.getDate() + 1);

      // Aller temporairement ailleurs puis revenir
      calendarApi.gotoDate(tempDate); // Change la date (déclenche datesSet)
      calendarApi.gotoDate(currentDate); // Reviens à la date initiale (redéclenche datesSet)
    },
    closeModalAndSave() {
      let that = this;

      if (this.autoPostData)
        engine.set_auto_post_data(
          this.groupInformation.id,
          JSON.stringify(this.autoPostData),
          function () {
            that.getUserData(function () {
              that.setPlanning();
            });
          }
        );
      this.isSavePageOpen = false;
    },
    getPuclicationDate(dayNumber) {
      const today = moment(); // date actuelle
      const currentDay = today.date();

      // Si le jour est dans le futur ce mois-ci
      if (dayNumber > currentDay) {
        const thisMonthDate = moment().date(dayNumber);
        if (thisMonthDate.isValid()) {
          return thisMonthDate.format("LL");
        }
      }

      // Sinon on prend le mois prochain
      const nextMonthDate = moment().add(1, "month").date(dayNumber);
      if (nextMonthDate.isValid()) {
        return nextMonthDate.format("LL");
      }

      // Si la date est invalide (ex: 31 février), on ajuste au dernier jour valide
      const lastValidDay = moment().add(1, "month").endOf("month").date();
      const adjustedDate = moment()
        .add(1, "month")
        .date(Math.min(dayNumber, lastValidDay));
      return adjustedDate.format("LL");
    },
    editPublication(data) {
      this.selectedGeneratonData = {
        modal: true,
        data: data.extendedProps.data,
      };
    },
    updatePublication() {
      let index = this.autoPostData[this.selectedSiteToShow.uuid]["nbr_progra"].findIndex(
        (val) => val.uuid == this.selectedGeneratonData.data.uuid
      );

      this.autoPostData[this.selectedSiteToShow.uuid]["nbr_progra"][
        index
      ] = this.selectedGeneratonData.data;

      this.selectedGeneratonData = {
        modal: false,
        data: undefined,
      };

      this.closeModalAndSave();
    },
    eventClicked(e) {
      if (e.event.extendedProps && e.event.extendedProps.isGenerate == 0) {
        this.snackData = {
          model: true,
          color: "green",
          label: "Génération de l’article est en cours. Temps estimé : 5 à 10 minutes.",
        };
      } else if (e.event.extendedProps && e.event.extendedProps.type != "récurrence") {
        let id = e.event._def.publicId;
        let findedData = this.dataListe.find((val) => val.publication_id == id);
        this.modalData = { data: findedData, publication_id: id };
        this.modalIsOpen["editShopifyArticle"] = true;
        // this.openProgrammation(item);
      } else {
        let month = moment(e.event.start).format("MMMM YYYY");
        let localMonth = moment().format("MMMM YYYY");

        if (month != localMonth) {
          this.snackData = {
            model: true,
            color: "red",
            label: "Cet article vous sera proposé au début du mois de " + month,
          };
        } else this.editPublication(e.event);
      }
    },
    setPlanning() {
      this.eventsListeRecu = [];
      let postData = this.autoPostData;

      let localEvent = [];

      this.autoPostDataInfo = { size: undefined, actived: 0 };
      if (postData) {
        let tab = Object.values(postData)
          .map((val) => val.nbr_progra)
          .flat();

        this.autoPostDataInfo.size = tab.length;
        let nbrActived = tab.filter((val) => val.isActived == 1);
        if (nbrActived) this.autoPostDataInfo.actived = nbrActived.length;

        for (let i = 0; i < tab.length; i++) {
          let elem = tab[i];
          let localDate = moment();

          elem.date = parseInt(elem.date);
          localDate.date(elem.date);
          localDate.month(
            parseInt(moment(this.onDatesChangeArgs.startStr).format("M")) - 1
          );

          let color = "#90A4AE";

          if (
            moment().isSameOrBefore(localDate) &&
            elem.date &&
            elem.date > 0 &&
            elem.isActived == 1
          )
            if (
              (elem.isGenerate == 0 && localDate.isSame(moment(), "month")) ||
              !localDate.isSame(moment(), "month")
            )
              localEvent.push({
                id: elem.uuid,
                type: "récurrence",
                start: localDate.format("YYYY-MM-DD"),
                data: elem,
                color,
                title:
                  '<div class="fc-event-title" style="border-radius:3px;width:100% !important;">' +
                  // '<div style="font-weight:normal">' +
                  // tagsHtml +
                  // "</div>" +
                  '<div style="color:white;font-weight:normal">' +
                  (elem.requeste.length == 0
                    ? "RC non choisie : sélection automatique"
                    : "<strong>RC </strong> :" + elem.requeste) +
                  "</div>" +
                  "</div>",
                // rrule: {
                //   freq: "monthly",
                //   bymonthday: parseInt(elem.date),
                //   dtstart: moment().format(),
                //   until: moment().add(6, "M").format("YYYY-MM-DD"),
                // },
                disableClick: true,
                // backgroundColor: color,
                // duration: "01:00", // 1 heure
              });
        }
      }

      this.eventsListeRecu = localEvent;
    },
    onDatesChange(arg) {
      let that = this;
      this.eventsListe = [];
      let localEvent = [];

      if (arg == undefined) arg = this.onDatesChangeArgs;
      else this.onDatesChangeArgs = arg;

      engine.get_generations_between_date(arg.startStr, arg.endStr, function (data) {
        if (data.state == 200) {
          that.dataListe = data.data;
          for (let i = 0; i < data.data.length; i++) {
            // let spanAlert = {
            //   generation: "", //'<span style="color:#D32F2F;">En cours de génération<span>',
            //   publish: "", //'<span style="color:black;font-weight:bold">Publié<span>',
            //   desactived: "",
            //   // '<span style="color:rgba(0,0,0,1);font-weight:bold">Publication désactivée<span>',
            //   past: "",
            //   // '<span style="color:rgba(50,0,0,1);font-weight:bold">À reprogrammer<span>',
            //   waiting: "",
            //   // '<span style="color:rgba(50,0,0,1);font-weight:bold">Publication à venir<span>',
            // };
            // let spanIsGenerate = '<span style="color:red">dddd<span>'

            let color = "#EF5350";
            let tagsHtml = "";
            // let icon = "";

            if (data.data[i].isGenerate == 0) {
              tagsHtml += '<span">En cours de génération<span>';
              color = "purple";
              // icon = "⌛ ";
            } else if (data.data[i].isPosted == 1) {
              if (that.initialView == "listMonth" || that.isMobile) {
                let title = that.legend.find((val) => val.key == "publish");
                if (title) tagsHtml += title.title;
              }
              // icon = "✅ ";
              color = "#388E3C";
            } else if (data.data[i].isPosted == 2) {
              if (that.initialView == "listMonth" || that.isMobile) {
                let title = that.legend.find((val) => val.key == "desactived");
                if (title) tagsHtml += title.title;
              }
              // icon = "❌ ";
              color = "#D32F2F";
            } else {
              if (moment().isBefore(data.data[i].publication_date)) {
                if (that.initialView == "listMonth" || that.isMobile) {
                  let title = that.legend.find((val) => val.key == "waiting");
                  if (title) tagsHtml += title.title;
                }
                // icon = "🟢 ";
                color = "#303F9F";
              } else {
                if (that.initialView == "listMonth" || that.isMobile) {
                  let title = that.legend.find((val) => val.key == "past");
                  if (title) tagsHtml += title.title;
                }
                // icon = "⚠️ ";
                color = "#F57C00";
              }
            }

            localEvent.push({
              id: data.data[i].publication_id,
              isPosted: data.data[i].isPosted,
              isGenerate: data.data[i].isGenerate,
              title:
                '<div class="fc-event-title fc-event-title-mobile;" style="background-color:' +
                color +
                ';border-radius:7px;">' +
                tagsHtml +
                '<div style="color:white;font-weight:normal;">' +
                // icon +
                (that.isMobileM ? "<strong>RC </strong> : " : "") +
                data.data[i].target_query +
                "</div>" +
                "</div>",
              start: data.data[i].publication_date,
              color,
            });
          }
          that.eventsListe = localEvent;
        }
        that.setPlanning();
      });
    },
  },
  computed: {
    getAllEvents() {
      let events = [];
      if (this.eventsListeRecu && this.eventsListeRecu.length > 0)
        events = events.concat(this.eventsListeRecu);
      if (this.eventsListe && this.eventsListe.length > 0)
        events = events.concat(this.eventsListe);

      return events;
    },
    isMobileSm() {
      // return this.$vuetify.display.mdAndUp && this.$vuetify.display.lgAndDown
      return this.$vuetify.display.mdAndUp;
    },
    isMobileM() {
      // return this.$vuetify.display.mdAndUp && this.$vuetify.display.lgAndDown
      return this.$vuetify.display.sm || this.$vuetify.display.md;
    },
    isMobileXs() {
      return this.$vuetify.display.name;
    },
    isMobile() {
      return this.$vuetify.display.mobile;
    },
    getNbrLoadingArticle() {
      let nbr = 0;

      if (this.user_squeduel_liste && this.user_squeduel_liste.length > 0)
        nbr = this.user_squeduel_liste.filter((val) => val.isGenerate == 0).length;

      return nbr;
    },
    getProgrammedArticleTitle() {
      return this.autoPostData[this.selectedSiteToShow.uuid]["nbr_progra"]
        .map((val) => val.requeste)
        .filter((val2) => val2.length > 0);
    },
    calendarOptions() {
      let that = this;
      return {
        locale: fr,
        height: this.windowHeight - 178,
        showNonCurrentDates: false,
        fixedWeekCount: false,
        eventClick: this.eventClicked,
        plugins: [dayGridPlugin, listPlugin],
        initialView: this.initialView,
        // initialView: "dayGridMonth",
        events: this.getAllEvents,
        // height: 'auto', // adapte la hauteur, évite le scroll
        contentHeight: "scroll",
        titleFormat: { year: "numeric", month: "short", day: "numeric" },
        headerToolbar: {
          left:
            "prev" +
            (this.isMobileSm ? " today" : "") +
            (this.isMobile ? "" : " myCustomButton"),
          center: "title",
          right: "next",
        },
        customButtons: {
          myCustomButton: {
            text:
              "📅 Publication mensuelle automatique ( " +
              this.autoPostDataInfo.actived +
              " / " +
              this.autoPostDataInfo.size +
              " )",
            click() {
              that.plannificationPramsDataIsOpen = true;
            },
          },
        },
        eventContent: function (arg) {
          let eventDate = arg.event.start;
          // let viewDate = arg.view.currentStart;
          let momentDate = parseInt(moment().format("M")) - 1;
          let momentYears = parseInt(moment().format("YYYY"));

          let isSameMonth =
            eventDate.getMonth() == momentDate && eventDate.getFullYear() === momentYears;

          let title = arg.event.title;

          if (arg.event.extendedProps.type == "récurrence") {
            if (arg.event.extendedProps.data.isActived == 1) {
              if (isSameMonth) {
                // Mois courant : rendu normal
                if (arg.event.extendedProps.data.isGenerate == 0)
                  return {
                    html: `<div style="font-weight: bold;">${title}</div>`,
                  };
              } else {
                // Autre mois (ex: jour visible sur les bords du mois)
                return {
                  html:
                    `<div style=" font-style: italic;background-color:#E0E0E0;border:solid 1px red">` +
                    '<div class="fc-event-title">Pour cette date un article sera proposé en début de mois' +
                    '<div style="color:white;font-weight:normal">' +
                    // data.data[i].title +
                    "</div>" +
                    "</div>" +
                    `</div>`,
                };
              }
            }
          } else {
            return {
              html: `<div style="font-weight: bold;">${title}</div>`,
            };
          }
        },
        // eventContent: function (arg) {
        //   let customEl = document.createElement("div");
        //   customEl.innerHTML = arg.event.title;
        //   return { domNodes: [customEl] };
        // },
        datesSet: this.onDatesChange,
      };
    },
  },
};
</script>

<style>
.fc-event div {
  width: 100%;
}

.fc-event-title {
  width: 100% !important;
  cursor: pointer;
  padding: 6px !important;
  white-space: normal;
  overflow-wrap: break-word;
  word-break: break-word;
  font-size: 12px;
  color: black !important;
}

.fc-event-title-mobile {
  display: -webkit-box !important;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: scroll;
  text-overflow: ellipsis;
  white-space: normal !important;
}

.fc-daygrid-day-top {
  text-align: center !important;
  justify-content: center;
}

.fc-daygrid-day-number {
  margin-top: 5px;
  font-size: 13px;
  padding: 0px !important;
  width: 23px;
  height: 18px;
  text-align: center; /* centre horizontalement le texte */
  border-radius: 50%; /* arrondir à 100% pour le cercle */
  color: var(--C1); /* couleur du texte */
  background-color: rgb(0, 0, 0, 0.2);
  display: inline-block; /* important pour que la bordure s’applique bien */
}

.fc-button.fc-next-button {
  background-color: transparent !important;
  border: none !important;
  color: var(--BG) !important;
  font-size: 25px !important;
  font-weight: bold;
  padding: 0px !important;
  padding-top: 0px !important;
  padding-bottom: 9px !important;
  padding-left: 5px !important;
  padding-right: 5px !important;
}

.fc-button.fc-prev-button {
  background-color: transparent !important;
  border: none !important;
  color: var(--BG) !important;
  font-size: 25px !important;
  font-weight: bold;
  padding: 0px !important;
  padding-top: 0px !important;
  padding-bottom: 9px !important;
  padding-left: 5px !important;
  padding-right: 5px !important;
}

.fc-list-event-time {
  display: none;
}

.fc-day-past {
  background-color: rgba(255, 0, 0, 0.1);
}
.fc-day-today {
  background-color: #b0bec5 !important;
}
.fc-day-future {
  background-color: rgba(0, 255, 0, 0.1);
}

/* .fc-button:hover{
  background-color: var(--C2) !important;
} */

/* .calendar-text {
  font-size: 12px !important;
}

.fc-event:hover {
  background-color: red !important;
  color: var(--C1);
  border: none !important;
  cursor: pointer;
}

.fc-event {
  background-color: white !important;
  color: var(--C1);
  border: none !important;
} */
</style>
